import React, { useContext } from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import { MdDevices } from 'react-icons/md';
import { IoMdLogOut } from 'react-icons/io';
import { LanguageContext } from '../../libs/Context';
import './styles.css';

interface ForcedLogoutPopupProps {
	open: boolean;
}

const ForcedLogoutPopup: React.FC<ForcedLogoutPopupProps> = ({ open }) =>
{
	const { language } = useContext(LanguageContext);

	return (
		<Dialog
			open={open}
			disableEscapeKeyDown
			disableScrollLock
			PaperProps={{
				sx : {
					borderRadius    : '12px',
					padding         : '24px',
					maxWidth        : '400px',
					width           : '100%',
					backgroundColor : '#fff',
					boxShadow       : '0 8px 32px rgba(0, 0, 0, 0.12)',
					margin          : '16px'
				}
			}}
			BackdropProps={{
				sx : {
					backgroundColor : 'rgba(0, 0, 0, 0.5)'
				}
			}}
			sx={{
				'& .MuiDialog-container' : {
					alignItems : 'center'
				}
			}}
		>
			<DialogContent sx={{ padding: 0, overflow: 'hidden' }}>
				<Box
					sx={{
						display       : 'flex',
						flexDirection : 'column',
						alignItems    : 'center',
						textAlign     : 'center',
						gap           : '20px',
						minHeight     : '280px'
					}}
				>
					{/* Icon */}
					<Box
						sx={{
							position        : 'relative',
							width           : '80px',
							height          : '80px',
							display         : 'flex',
							alignItems      : 'center',
							justifyContent  : 'center',
							backgroundColor : '#FEE2E2',
							borderRadius    : '50%'
						}}
					>
						<MdDevices size={40} color='#DC2626' />
						<Box
							sx={{
								position        : 'absolute',
								bottom          : '-5px',
								right           : '-5px',
								width           : '32px',
								height          : '32px',
								backgroundColor : '#DC2626',
								borderRadius    : '50%',
								display         : 'flex',
								alignItems      : 'center',
								justifyContent  : 'center',
								border          : '3px solid #fff'
							}}
						>
							<IoMdLogOut size={18} color='#fff' />
						</Box>
					</Box>

					{/* Title */}
					<Typography
						variant='h5'
						sx={{
							fontWeight : 600,
							color      : '#111827',
							fontSize   : '1.5rem'
						}}
					>
						{language?.sessionTerminated || 'Session Terminated'}
					</Typography>

					{/* Message */}
					<Typography
						sx={{
							color      : '#6B7280',
							fontSize   : '0.875rem',
							lineHeight : 1.6
						}}
					>
						{language?.forcedLogoutMessage ||
							'This session has been logged out from another device. You will be redirected to the login page.'}
					</Typography>

					{/* Loading indicator */}
					<Box
						sx={{
							display        : 'flex',
							alignItems     : 'center',
							gap            : '12px',
							marginTop      : '8px',
							justifyContent : 'center'
						}}
					>
						<Box className='forced-logout-spinner' />
						<Typography
							sx={{
								color      : '#9CA3AF',
								fontSize   : '0.875rem',
								fontWeight : 500
							}}
						>
							{language?.loggingOut || 'Logging out...'}
						</Typography>
					</Box>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default ForcedLogoutPopup;
